import { defineStore } from 'pinia'
import buildQueryString from '../../helpers/query-builder'

export const useShipmentsStore = defineStore('shipments', {
  state: () => ({
    baseUrl: '',
    exportCsvUrl: '',
    filters: {
      // Initial filters
      brand: '',
      box_month_content: '',
      content_description: '',
      csv: '',
      printed_at: {
        starts_at: undefined,
        ends_at: undefined
      },
      shipment_invoice_name: '',
      shipment_name: '',
      shippable_starts_at: {
        starts_at: undefined,
        ends_at: undefined
      },
      shippable_ends_at: {
        starts_at: undefined,
        ends_at: undefined
      },
      shipper_memo: '',
      shipping_methods: {
        include: []
      },
      shipping_method_print_option: '',
      subscription_box_brands: {
        include: []
      },
      transacted: undefined,
      country: ''
    },
    shippingMethods: [],
    shippingMethodPrintOptions: [],
    boxBrands: [],
    countries: [],
    transactedOptions: [
      { id: 'all', name: 'All' },
      { id: '1', name: 'Yes' },
      { id: '0', name: 'No' }
    ],
    printStatusOptions: [
      { id: 'all', name: 'All' },
      { id: 'processing', name: 'Processing' },
      { id: 'printed', name: 'Printed' },
      { id: 'transacted', name: 'Transacted' },
      { id: 'cancelled', name: 'Cancelled' },
      { id: 'print_failed', name: 'Print Failed' },
    ],
    exportType: [
      { id: "shipment_csv", name: "Shipment CSV" },
      { id: 'taxually', name: 'Taxually' },
      { id: 'incident_report', name: 'Incident report' },
      { id: 'print_error_report', name: 'Print error report' },
      { id: 'ingredients_en', name: 'Ingredients List (EN)' },
      { id: 'ingredients_jp', name: 'Ingredients List (JP)' },
      { id: 'invoice_pdf', name: 'Invoice PDF' },
      { id: 'invoice_pdf_buy_price', name: 'Invoice PDF (Buy Price)' },
      { id: 'abi_manufacturer_csv', name: 'ABI Manufacturer CSV' },
      { id: 'customer_csv', name: 'Customer CSV' }
    ],
    // PDF export types that require selected shipment IDs
    pdfExportTypes: [
      'ingredients_en',
      'ingredients_jp',
      'invoice_pdf',
      'invoice_pdf_buy_price',
      'abi_manufacturer_csv',
      'customer_csv'
    ]
  }),

  getters: {
    isBrandSubscriptionBoxes: (state) => state.filters.brand === 'SubscriptionBoxes',
    isTestShippingSelected: (state) =>
      state.filters.shipping_methods.include.includes(
        Object.keys(state.shippingMethods).find(
          (key) => state.shippingMethods[key] === 'Test Shipping'
        )
      )
  },

  actions: {
    setInitialState(data) {
      const initialData = data.value
      Object.keys(initialData).forEach((key) => {
        // We want to make sure the filters are set individually and not replaced as a whole object.
        if (key === 'filters') {
          this.setFilters(initialData[key])
          return
        }
        this[key] = initialData[key]
      })
    },
    setFilters(filters) {
      Object.keys(filters).forEach((key) => {
        this.filters[key] = filters[key]
      })
    },
    handleSubmit(event) {
      const bodyParams = buildQueryString(this.filters)

      // Check if this is a PDF export type that requires selected shipment IDs
      if (event === 'csv' && this.pdfExportTypes.includes(this.filters.export_type)) {
        // Get selected shipment IDs from Stimulus controller
        const stimulusController = document.querySelector('[data-controller="shipments-index"]')
        if (stimulusController) {
          const controller = window.Stimulus?.getControllerForElementAndIdentifier(stimulusController, 'shipments-index')
          if (controller) {
            const shipmentIds = controller.getSelectedShipmentIds()
            if (shipmentIds.length === 0) {
              alert('Please select at least one shipment to export.')
              return
            }
            const url = `${this.exportCsvUrl}?${bodyParams}&shipment_ids=${shipmentIds.join(',')}`
            window.location.href = url
            return
          }
        }
      }

      const url = `${event === 'csv' ? this.exportCsvUrl : this.baseUrl}?${bodyParams}`

      window.location.href = url
    }
  }
})
